import config from '@/config/config.js';


export default {

	trace(...param){

		if (config.debug ) {
			console.log("%c%s", "color: #4C4C4C; background: white; font-size: 14px;","[trace]:"+__dirname+__filename, param)
		}
	},
	info(...param){

		if (config.debug) {
			console.info("%c%s", "color: #000000; background: white; font-size: 14px;","[info]:"+__dirname+__filename, param)
		}
	},
	debug(...param){

		if (config.debug) {
			console.log("%c%s", "color: #91D300; background: white; font-size: 14px;","[debug]"+__dirname+__filename, param)
		}
	},

	warn(...param){

		if (config.debug ) {
			console.warn("%c%s", "color: #FA9D3B; background: white; font-size: 14px;", "[warn]:"+__dirname+__filename, param)
		}
	},
	error(...param){
		if (config.debug ) {
			console.error("%c%s", "color: red; background: white; font-size: 14px;","[error]:"+__dirname+__filename, param)
		}

	},

}



